import { createTheme } from "@mui/material/styles";

const getTheme = (mode = "light") =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: mode === "dark" ? "#2FE0AE" : "#00A67E",
      },
      secondary: {
        main: mode === "dark" ? "#8FA8BF" : "#3B5568",
      },
      background: {
        default: mode === "dark" ? "#12181A" : "#FAFBFA",
        paper: mode === "dark" ? "#1B2325" : "#ffffff",
      },
      text: {
        primary: mode === "dark" ? "#EDEFEE" : "#1C2624",
        secondary: mode === "dark" ? "#A9B4B2" : "#5B6664",
      },
      divider: mode === "dark" ? "rgba(255,255,255,0.12)" : "rgba(28,38,36,0.12)",
      custom: {
        pastelYellow: mode === "dark" ? "#7a7020" : "#FFF176",
        mintGreen: mode === "dark" ? "#1a3a35" : "#E0F7F2",
        darkCharcoal: mode === "dark" ? "#e0e0e0" : "#333333",
      },
    },
    shape: {
      borderRadius: 10,
    },
    typography: {
      fontFamily: '"Inter", "Arial", sans-serif',
      h3: { fontWeight: 700, letterSpacing: "-0.01em" },
      h5: {
        fontSize: "16px",
        fontWeight: 600,
      },
      h6: { fontWeight: 600 },
      body1: {
        fontSize: "14px",
      },
      body2: { fontSize: "13.5px" },
      caption: {
        fontSize: "12px",
      },
      button: { fontWeight: 600 },
    },
    spacing: 8,
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          html: {
            margin: 0,
            padding: 0,
            width: "100%",
            height: "100%",
          },
          body: {
            margin: 0,
            padding: 0,
            width: "100%",
            height: "100%",
            overflowX: "hidden",
          },
          "#root": {
            margin: 0,
            padding: 0,
            width: "100%",
            height: "100%",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 10,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
        defaultProps: {
          elevation: 0,
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: mode === "dark" ? "#555555" : undefined,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: mode === "dark" ? "#aaaaaa" : undefined,
            },
          },
          input: {
            backgroundColor: mode === "dark" ? "#2a2a2a" : undefined,
            borderRadius: 4,
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: mode === "dark" ? "#aaaaaa" : undefined,
          },
        },
      },
    },
  });

export default getTheme;
